import { AppState } from "../../../redux-configuration/AppState";
import { StatsCompany } from "../../domain/entity/statsCompany";
import { StatsProfile } from "../../domain/entity/statsProfile";

export const retrieveSuperAdminStatsLoadingSelector = (state: AppState): boolean => state.stats.superAdmin.loading
export const retrieveSuperAdminStatsErrorSelector = (state: AppState): string | undefined => state.stats.superAdmin.error
export const retrieveSuperAdminStatsProfilesSelector = (state: AppState): StatsProfile[] | undefined => state.stats.superAdmin.profiles
export const retrieveSuperAdminStatsCompaniesSelector = (state: AppState): StatsCompany[] | undefined => state.stats.superAdmin.companies
